import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import userProfileKeys from './queryKeys';
import config from 'utils/config';
export function fetchMindsetSettings() {
  return _fetchMindsetSettings.apply(this, arguments);
}
function _fetchMindsetSettings() {
  _fetchMindsetSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", api('get', '/api/mindset/agent', null));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchMindsetSettings.apply(this, arguments);
}
function useFetchUserMindsetSettings() {
  var _useQuery = useQuery({
      queryKey: userProfileKeys.mindsetAgent,
      queryFn: fetchMindsetSettings,
      staleTime: 5 * 60 * 1000,
      enabled: !!config.mindsetAppUid
    }),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    mindsetAgent: data,
    hasMindsetAgent: Boolean(data === null || data === void 0 ? void 0 : data.agentUid),
    hasMindsetApp: Boolean(data === null || data === void 0 ? void 0 : data.appUid)
  }, result);
}
export default useFetchUserMindsetSettings;